<template>
  <div class="rate-overall-stats">
    <ElRate v-model="rateAverage" disabled />
    <div class="rate-overall-stats__content">
      <i class="material-icons">star</i>
      <span>{{ rateAverage }}</span>
      <span class="rate-overall-stats__spacer" />
      <i class="material-icons">person</i>
      <span>{{ formattedTotalCount }}</span>
    </div>
  </div>
</template>

<script>
import { format as numberFormat } from '@/utils/number';
export default {
  name: 'RateOverallStats',
  props: {
    rateAverage: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    formattedTotalCount() {
      return numberFormat(this.totalCount);
    },
  },
};
</script>

<style lang="scss">
.rate-overall-stats {
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
  align-items: center;
  justify-content: center;

  @include breakpoint(small down) {
    align-content: center;
    margin-bottom: $global-margin * 2;
  }

  &__content {
    margin-top: $global-margin;
    font-size: $global-font-size * 1.4;

    i {
      margin-right: $global-margin/3;
      color: $lb-darker-gray;
      font-size: $global-font-size;
    }

    span {
      vertical-align: -3px;
    }
  }

  &__spacer {
    border-right: 1px solid $lb-light-gray;
    margin: 0 $global-margin / 2;
  }
}
</style>
